import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Sidebar collapse state — shared so the topbar can host the collapse toggle
 * while the sidebar reads the width. Persisted under `ukn_sidebar_collapsed`
 * (same key the sidebar used for its old local state, so the preference
 * carries over).
 */
type SidebarState = {
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
  toggle: () => void;
};

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      setCollapsed: (v) => set({ collapsed: v }),
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
    }),
    { name: 'ukn_sidebar_collapsed_v2' },
  ),
);
